import ErrorBox from '@components/common/ErrorBox';
import ProductBoutiqueSelected from '@moncler/components/reserve/ProductBoutiqueSelected';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import DwFormFieldPhoneWithPrefix from '@ui/formfield/DwFormFieldPhoneWithPrefix';
import analytics from '@utils/analytics';
import api from '@utils/api';
import { BAA } from '@utils/constants';
import formutils from '@utils/formutils';
import createDecorator from 'final-form-focus';
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import BookAnAppointmentConfirmationPage from './BookAnAppointmentConfirmationPage';
import BookAnAppointmentDateSelection from './BookAnAppointmentDateSelection';
import BookAnAppointmentReasonMessage from './BookAnAppointmentReasonMessage';
import BookAnAppointmentStoreSelector from './BookAnAppointmentStoreSelector';
import BagInfoBox from '../bag/BagInfoBox';
import LoginModal from '@components/login/LoginModal';
const focusOnError = createDecorator(); // must be outside the component
const BookAnAppointmentForm = (props) => {
    const { t } = useTranslation();
    const [requestSent, setRequestSent] = useState();
    const [appointmentresponse, setAppointmentresponse] = useState();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [errors, setErrors] = useState([]);
    const [days, setDays] = useState({});
    const [store, setStore] = useState(props.store);
    const [appointmentType, setAppointmentType] = useState(BAA.APPOINTMENT.INSTORE);
    const [collections, setCollections] = useState([]);
    const appointmentSection = useRef(null);
    const [loginOpen, setLoginOpen] = useState(false);
    const [loginEmail, setLoginEmail] = useState();
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [phone, setPhone] = useState();
    const [phonePrefix, setPhonePrefix] = useState();
    const [resetFields, setResetFields] = useState(false);
    const [isLoading, setIsloading] = useState(false);
    const [reasonSelect, setReasonSelect] = useState();
    const [availableSlotTypes, setAvailableSlotTypes] = useState();
    const tabsMap = {
        '552250000': t('bookanappointment.appointmentinstoreanalytics'),
        '552250001': t('bookanappointment.virtualappointmentanalytics'),
    };
    const lastArg = useRef();
    useEffect(() => {
        let isMounted = true;
        let val = {};
        api.getForm('bookanappointment', val, true).then((data) => {
            var _a;
            setFirstName(data.firstname.htmlValue);
            setLastName(data.lastname.htmlValue);
            setPhone(data.phone.htmlValue);
            setPhonePrefix(data.phonePrefix.htmlValue);
            setLoginEmail(data.email.htmlValue);
            if (!val.appointmenttype) {
                val.appointmenttype = BAA.APPOINTMENT.INSTORE;
            }
            if (props.type == 'mbm' && !val.reason) {
                val.reason = BAA.REASONS.PERSONALIZATION;
            }
            // filtra la personalization reason in base alla global preference activateMbmReasonContact
            if (!window.mbmContactReason) {
                data.reason.options = data.reason.options.filter((o) => o.value != BAA.REASONS.PERSONALIZATION);
            }
            // store without personalization room, filter it out from reasons
            if (props.type == 'modal' && !((_a = store === null || store === void 0 ? void 0 : store.storeServices) === null || _a === void 0 ? void 0 : _a.personalizationRoom)) {
                data.reason.options = data.reason.options.filter((o) => o.value != BAA.REASONS.PERSONALIZATION);
            }
            if (props.recipeid) {
                val.recipeid = props.recipeid;
                val.size = props.size;
            }
            if (!props.activeTabs) {
                api.getPageJson('bookappointment', true).then((bookData) => {
                    if (bookData.data.activeTabs == 'Physical') {
                        data.appointmenttype.options = data.appointmenttype.options.filter((option) => option.value == BAA.APPOINTMENT.INSTORE.toString());
                        val.appointmenttype = BAA.APPOINTMENT.INSTORE;
                    }
                    else if (bookData.data.activeTabs == 'Virtual') {
                        data.appointmenttype.options = data.appointmenttype.options.filter((option) => option.value == BAA.APPOINTMENT.VIRTUAL.toString());
                        val.appointmenttype = BAA.APPOINTMENT.VIRTUAL;
                    }
                });
            }
            else {
                if (props.activeTabs == 'Physical') {
                    data.appointmenttype.options = data.appointmenttype.options.filter((option) => option.value == BAA.APPOINTMENT.INSTORE.toString());
                    val.appointmenttype = BAA.APPOINTMENT.INSTORE;
                }
                else if (props.activeTabs == 'Virtual') {
                    data.appointmenttype.options = data.appointmenttype.options.filter((option) => option.value == BAA.APPOINTMENT.VIRTUAL.toString());
                    val.appointmenttype = BAA.APPOINTMENT.VIRTUAL;
                }
            }
            if (isMounted) {
                if (appointmentType != val.appointmenttype) {
                    setAppointmentType(val.appointmenttype);
                }
                setInitialValues(val);
                setFormdef(data);
            }
        });
        return () => {
            isMounted = false;
        };
    }, []);
    useEffect(() => {
        var _a;
        if (store) {
            setIsloading(true);
            (_a = document.querySelector('.storelist')) === null || _a === void 0 ? void 0 : _a.classList.add('disabled');
            api
                .bookAnAppointmentSlots(store === null || store === void 0 ? void 0 : store.ID, appointmentType != BAA.APPOINTMENT.VIRTUAL ? availableSlotTypes : appointmentType, false, reasonSelect)
                .then((data) => {
                setDays(data.days);
                if (data) {
                    document.querySelector('.storelist').classList.remove('disabled');
                }
                if (props.type != 'mbm') {
                    api.bookAnAppointmentCollections(store === null || store === void 0 ? void 0 : store.ID).then((data) => {
                        setCollections(data);
                    });
                }
            })
                .finally(() => {
                setIsloading(false);
            });
        }
    }, [store, appointmentType]);
    const checkHourValueInDays = (appointmentValue, form, values) => {
        if (values.date && values.hour) {
            api.bookAnAppointmentSlots(store === null || store === void 0 ? void 0 : store.ID, appointmentValue != BAA.APPOINTMENT.VIRTUAL ? availableSlotTypes : appointmentValue, false, reasonSelect).then((data) => {
                if (data.days) {
                    let day = data.days[values.date];
                    if (day && day.length > 0) {
                        let hour = day.find((hourObj) => hourObj.value == values.hour);
                        if (!hour) {
                            form.mutators.global({ hour: '' });
                        }
                    }
                }
            });
        }
    };
    const prefillValues = (values) => {
        values.storeid = store === null || store === void 0 ? void 0 : store.ID;
        if (appointmentType != BAA.APPOINTMENT.VIRTUAL) {
            values.appointmenttype = availableSlotTypes;
        }
        if (values.appointmenttype == BAA.APPOINTMENT.VIRTUAL && values.reason == BAA.REASONS.PERSONALIZATION) {
            values.reason = undefined;
        }
    };
    const validate = async (values, onSubmit) => {
        if (window.loggedin) {
            values.privacyFlag = true;
        }
        prefillValues(values);
        // In order to keep full validation of all the form and the automatic assignment of the current country in the countrySelect, there are multiple validation calls that occour on re-renderings.
        // When the validation is called with the same values as the last one, nothing is returned. In each and every case of this specific form we will have a subsequential validation that will generate a valid response, so no problems will arise.
        // This code can address the issue described in the ticket OE-17125 only, do not use it elsewhere.
        let different = false;
        if (lastArg.current) {
            new Set([...Object.keys(lastArg.current), ...Object.keys(values)]).forEach((valKey) => {
                if ((values[valKey] || '') !== (lastArg.current[valKey] || ''))
                    different = true;
            });
        }
        else {
            different = true;
        }
        if (different || onSubmit) {
            lastArg.current = values;
            return await formutils.validateForm(values, formdef, 'bookanappointment');
        }
    };
    const onSubmit = async (values) => {
        setErrors([]);
        let err = await validate(values, true);
        if (err && Object.keys(err).length > 0) {
            return err;
        }
        await api.bookAnAppointmentSubmit(values, formdef).then((data) => {
            var _a;
            // console.log('after submit: ' + JSON.stringify(data, null, 2));
            if (typeof data === 'undefined') {
                // -- setShowOverlay(false) if same appointment ?
                return;
            }
            if (data.error && data.error.length > 0) {
                setErrors(data.error);
                return;
            }
            // https://jira.industries-group.com/browse/MOM-3264
            // let errors: models.ValidationErrors = {};
            // if (!formutils.checkValidationAfterSubmit(data, errors)) {
            //   return errors;
            // }
            if (props.type != 'mbm') {
                // -- not mbm
                // analytics.bookAppointmentSubmit(props.product?.masterId);
                analytics.storelocatorBookAppointment(['modal', 'mbm'].includes(props.type) ? 'storelocator' : 'footer', `submit-moncler ${store.name}`);
            }
            else {
                if (props.paletteName) {
                    // -- configuration
                    analytics.configuratorAction(props.fromContinueInStore ? 'continue in store' : 'product configuration', props.paletteName() + '-confirm appointment');
                }
                else {
                    // -- pdp
                    analytics.bookAppointmentSubmit((_a = props.product) === null || _a === void 0 ? void 0 : _a.masterId);
                }
            }
            setRequestSent(values);
            setAppointmentresponse(data);
            document.querySelector('.myaccount-hero').scrollIntoView({ behavior: 'smooth', inline: 'end' });
        });
    };
    if (formdef && requestSent && appointmentresponse) {
        return React.createElement(BookAnAppointmentConfirmationPage, Object.assign({ store: store, formdef: formdef, requestSent: requestSent, appointmentresponse: appointmentresponse, days: days }, props));
    }
    if (!formdef || !initialValues) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        props.type == 'modal' && !requestSent && !appointmentresponse && React.createElement("h1", { className: "dialog__title" }, t('bookanappointment.title')),
        React.createElement("div", { ref: appointmentSection, className: "product-reserve__detail__form scrollable" },
            React.createElement(Form, { initialValues: initialValues, onSubmit: onSubmit, validate: validate, decorators: [focusOnError], mutators: {
                    global: formutils.globalMutator,
                    resetHours: (args, state, utils) => {
                        utils.changeValue(state, 'hour', () => null);
                    },
                }, render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit },
                    props.type != 'mbm' &&
                        (formdef.appointmenttype.options.length == 1 ? (React.createElement("h2", { className: "tabs-single-tab-title" }, formdef.appointmenttype.options[0].label)) : (React.createElement(DwFormField, { def: formdef, name: "appointmenttype", type: "optionbox", onChange: (e) => {
                                setAppointmentType(e.target.value);
                                if (tabsMap) {
                                    analytics.clientServiceRedesignAnalytics(`${props.pagetitleforanalytics}`.toLowerCase(), tabsMap[e.target.value].toLowerCase());
                                }
                                checkHourValueInDays(e.target.value, form, values);
                            } }))),
                    React.createElement("div", { className: "wrapper-content-scrollable" },
                        ['modal', 'mbm'].includes(props.type) && (React.createElement(ProductBoutiqueSelected, { appointmentType: values.appointmenttype, store: store, onArrowBack: props.onArrowBack })),
                        React.createElement(React.Fragment, null,
                            props.type == 'page' && (React.createElement(React.Fragment, null, window.loggedin ? (React.createElement(React.Fragment, null,
                                values.appointmenttype === BAA.APPOINTMENT.VIRTUAL && (React.createElement("p", { className: "virtual-message" }, t('bookanappointment.virtualappointmentmsg'))),
                                values.appointmenttype && (React.createElement(BookAnAppointmentStoreSelector, Object.assign({ formdef: formdef, initialValues: initialValues }, props, { mutator: form.mutators.global, store: store, onSelect: setStore, appointmentType: values.appointmenttype, showmap: true, setReasonSelect: setReasonSelect, setAvailableSlotTypes: setAvailableSlotTypes, resetFields: resetFields, loaderSrc: props.loaderSrc }))))) : (React.createElement("div", { className: "mt-32 wrapper-box-login" },
                                React.createElement("p", { className: "primary-xs mb-40" }, t('bookanappointment.boxloginsubtitle')),
                                React.createElement(BagInfoBox, { text: t('bookanappointment.boxlogin'), noBanner: true, buttonAction: () => {
                                        setLoginOpen(true);
                                    } }))))),
                            store && (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "ReserveForm" },
                                    React.createElement(BookAnAppointmentDateSelection, { formdef: formdef, days: days, form: form, values: values, disabled: !store.ID || isLoading }),
                                    React.createElement("div", { className: "row" },
                                        props.type == 'modal' && (React.createElement("div", { className: values.reason == BAA.REASONS.DISCOVERCOLLECTION && (collections === null || collections === void 0 ? void 0 : collections.length) > 0 ? 'col-lg-6' : 'col-12' },
                                            React.createElement(DwFormField, { def: formdef, name: "reason", type: "select", options: values.appointmenttype != BAA.APPOINTMENT.VIRTUAL
                                                    ? formdef.reason.options
                                                    : formdef.reason.options.filter((o) => o.value != BAA.REASONS.PERSONALIZATION) }))),
                                        values.reason == BAA.REASONS.DISCOVERCOLLECTION && (collections === null || collections === void 0 ? void 0 : collections.length) > 0 && (React.createElement("div", { className: 'col-12' + (props.type == 'page' ? '' : ' col-lg-6') },
                                            React.createElement(DwFormField, { def: formdef, name: "collectionCode", type: "select", options: [{ value: '', label: t('label.select') }].concat(collections) || [], disabled: isLoading })))),
                                    React.createElement(BookAnAppointmentReasonMessage, { formdef: formdef, values: values, disabled: isLoading }),
                                    React.createElement("div", { className: "appointments-mandatoryField" },
                                        "*",
                                        t('label.mandatoryfields')),
                                    React.createElement("div", { className: "wrapper-info mt-32" },
                                        React.createElement("div", { className: "row mb-20 container-info-profile" },
                                            React.createElement("span", { className: props.type == 'modal' ? 'primary-xs-u col-12' : 'primary-xs-u col-sm-4' }, t('profile.namesurname')),
                                            React.createElement("span", { className: props.type == 'modal' ? 'bold col-12 primary-s' : 'bold col-sm-8 primary-s' },
                                                firstName,
                                                " ",
                                                lastName)),
                                        React.createElement("div", { className: "row mb-20 container-info-profile" },
                                            React.createElement("span", { className: props.type == 'modal' ? 'primary-xs-u col-12' : 'primary-xs-u col-sm-4' }, t('profile.email')),
                                            React.createElement("span", { className: props.type == 'modal' ? 'bold col-12 primary-s' : 'bold col-sm-8 primary-s' }, loginEmail)),
                                        phone && (React.createElement("div", { className: "row mb-20 container-info-profile" },
                                            React.createElement("span", { className: props.type == 'modal' ? 'primary-xs-u col-12' : 'primary-xs-u col-sm-4' }, t('profile.phonenumber')),
                                            React.createElement("span", { className: props.type == 'modal' ? 'bold col-12 primary-s' : 'bold col-sm-8 primary-s' },
                                                phonePrefix,
                                                " ",
                                                phone))),
                                        !phone && (React.createElement(React.Fragment, null,
                                            React.createElement("div", { className: "mb-12" },
                                                React.createElement("span", { className: "primary-xs" }, t('profile.additionalinfo'))),
                                            React.createElement(DwFormFieldPhoneWithPrefix, { def: formdef, uniqueLabel: t('profile.phonenumber') }))))),
                                React.createElement("div", { className: "product-reserve__detail__form__submit row" },
                                    props.type == 'page' && (React.createElement("div", { className: "col-sm-6 wrapper-button-arrow" },
                                        React.createElement(Button, { cls: ['button--tertiary', 'button--arrow-left'], onClick: () => {
                                                setResetFields(true);
                                                setStore(null);
                                                form.reset();
                                                if (props.type == 'page') {
                                                    let section = document.querySelector('#bookanappointement');
                                                    section.scrollIntoView({ behavior: 'smooth', inline: 'start' });
                                                    section.focus();
                                                }
                                            }, type: 'button' }, t('button.back')))),
                                    React.createElement("div", { className: props.type == 'page' ? 'col-sm-6' : 'col-12' },
                                        React.createElement(Button, { type: "submit", disabled: submitting, cls: ['button--primary'], onClick: () => {
                                                analytics.clientServiceRedesignAnalytics(`${props.pagetitleforanalytics}`, tabsMap[appointmentType.toString()].toLowerCase() + '-' + t('bookanappointment.confirmappointmentanalytics').toLowerCase());
                                            } }, t('bookanappointment.confirmappointment')))),
                                React.createElement(ErrorBox, { errors: errors }))))))) }),
            React.createElement(LoginModal, Object.assign({}, props, { inCart: true, reloadPage: true, reloadPageRegisteredInStore: true, modalStatus: loginOpen, analyticsKey: "modal", pageContext: "bookanappointment", updateStatus: (status) => setLoginOpen(status) })))));
};
export default BookAnAppointmentForm;
